import { db } from './api'

export const Chats = db.collection('chats')
